export default "__VITE_ASSET__37b1a4ff__"